import get from "lodash/get";
import { object } from "prop-types";
import React from "react";

import { getAiFaqStoryId, useAiFaqData } from "../../customHooks/useAiFaqData";
import { getAiSummaryEligibility } from "../../utils";
import AIHUBStoryWidget from "../AIHUBStoryWidget";
import GoAdFreeWidgetRed from "../GoAdFreeWidgetRed";
import "./StoryAiHubPromoWidget.m.css";

const hasItems = (items, requiredKeys = []) =>
  Array.isArray(items) && items.some((item) => requiredKeys.every((key) => Boolean(get(item, [key], ""))));

const StoryAiHubPromoWidget = ({ story, qtConfig, isStorypage }) => {
  const faqUrl = get(qtConfig, ["publisher-attributes", "publisher-faq-url"], false);
  const storyId = getAiFaqStoryId(story);
  const { shouldEnableAiHubForTextStory } = getAiSummaryEligibility({
    story,
    publisherConfig: get(qtConfig, ["publisher-attributes"], {}),
  });
  const {
    hasSummary,
    hasFaqs,
    hasTopic,
    hasKeyTakeaways,
    hasTimeline,
    hasGlossary,
    hasTweets,
    summary,
    topic,
    keyTakeaways,
    timeline,
    faqs,
    glossary,
    tweets,
    isLoading,
    hasInTheStory,
    inTheStory,
  } = useAiFaqData({
    faqUrl,
    storyId,
    enabled: faqUrl !== false && Boolean(storyId) && shouldEnableAiHubForTextStory,
  });

  const hasAiHubData =
    shouldEnableAiHubForTextStory &&
    !isLoading &&
    ((hasSummary && Boolean(summary)) ||
      (hasTopic && Boolean(topic)) ||
      (hasKeyTakeaways && Array.isArray(keyTakeaways) && keyTakeaways.some(Boolean)) ||
      (hasTimeline && hasItems(timeline, ["date", "event"])) ||
      (hasFaqs && hasItems(faqs, ["question", "answer"])) ||
      (hasGlossary && hasItems(glossary, ["term", "definition"])) ||
      (hasInTheStory && hasItems(inTheStory, ["name", "rankLabel", "href", "rankYear"])) ||
      (hasTweets && hasItems(tweets, ["id"])));

  return (
    <div styleName={`story-aihub-promo-widget ${hasAiHubData ? "show-aihub" : ""}`}>
      <div styleName="promo-widget-pane adfree-pane">
        <GoAdFreeWidgetRed customStyleName="story-page-ad-free-container" isStorypage />
      </div>
      {hasAiHubData ? (
        <div styleName="promo-widget-pane aihub-pane">
          <AIHUBStoryWidget customStyleName="story-page-aihub-widget-container" storyContentId={storyId} />
        </div>
      ) : null}
    </div>
  );
};

StoryAiHubPromoWidget.propTypes = {
  story: object.isRequired,
  qtConfig: object.isRequired,
};

export default StoryAiHubPromoWidget;
